<template>
  <div class="miya-login-left">
    <img class="logo" src="@assets/images/home/miyaLOGO.svg" @click.stop="$router.push('/home')">
    <div class="bg"></div>
    <div class="line"></div>
    <img class="i2" src="@assets/images/login/i.png">
    <img class="img" src="@assets/images/login/bg.png">
    <h1 class="text fontSH">
      <img class="i1" src="@assets/images/login/i.png">{{$t('login.thank')}}
    </h1>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {  
  },
  methods: {
  },
  beforeDestroy () {
  },
  components: {}
}
</script>
<style scoped lang="stylus">
.miya-login-left
  width 30%  
  background-color $c1
  position relative
  overflow hidden
  .logo
    position absolute
    width 178px
    left 64px
    top 48px
    z-index 1
    cursor pointer
  .bg
    position absolute
    width 2000px
    height 1200px
    top 0
    left 0
    transform translate3d(-50%,-50%,0) rotate(45deg)
    background: radial-gradient(rgba(255,143,16,0.25), rgba(35,25,15,0), rgba(35,25,15,0))
  .img
    position absolute
    left 50%
    bottom -20%
    transform translate3d(-65%, 0, 0)
  .text
    position absolute
    left 64px
    bottom 16%
    line-height: 58px;
    font-size 42px
    letter-spacing: 3px
    color #D0CFCE
    .i1
      position absolute
      top -42px
      bottom calc(16% + 70px)
  .line
    position absolute
    right 0
    top 0
    width 100px
    height 100%
    background: linear-gradient(90deg, rgba(47,31,14,0) 0%, #000000 100%);
    z-index 2
  .i2
    position absolute
    right 64px
    transform rotate(180deg)
    bottom calc(16% - 70px)
@media screen and (max-width: 800px) 
  .miya-login-left
    position absolute
    top 0
    left 0
    width 100vw
    min-height 800px
    height 100vh
    z-index 0
    .logo
      width 5rem
      left 1rem
      top 1rem
    .img
      bottom -60%
      opacity 0.3
    .text
      font-size 1.5rem
      left 1rem
      line-height 1.5rem
      bottom 12%
      color #929292
    .i1
      opacity 0.5
    .i2
      opacity 0.5
      bottom calc(12% - 1.5rem)
</style>